
export const headerData = {
    name: 'Safayetul Islam Sayem',
    title: "Hello! I am",
    desciption: "Hello there! I am a front-end web developer. As a passionate developer, I love to learn & explore new features of websites. I am a fast learner and a hard-working person who has been doing development for over a year. My goal is to become an awesome web developer.",
    image: 'https://i.ibb.co/SKT2jpk/safayet-pic.jpg',
    imagebw: 'https://i.ibb.co/SKT2jpk/safayet-pic.jpg',
    resumePdf: 'https://docs.google.com/document/d/1bBLZws5eqnW9gSynWQX5Lu-LzbF55kiZb03lQB1lm8Y/edit?usp=sharing'
}
